<template>
  <img v-if="src" :src="src" :class="_.img" @click="$emit('click')" />
  <span
    v-else
    :class="[_['ddmall-iconfont'], _[`ddmall-icon-${name}`]]"
    @click="$emit('click')"
  />
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      src: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        default: '',
      },
    },
  })
</script>

<style lang="scss" module>
  .img {
    user-select: none;
    -webkit-touch-callout: none;
    object-fit: cover;
  }

  @font-face {
    font-family: 'ddmall-iconfont';
    src: url('data:font/woff;charset=utf-8;base64,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')
      format('woff');
  }

  .ddmall-iconfont {
    font-family: 'ddmall-iconfont' !important;
    font-size: 1em;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .ddmall-icon-box::before {
    content: '\ef9d';
  }

  .ddmall-icon-share::before {
    content: '\ef9b';
  }

  .ddmall-icon-caret-down::before {
    content: '\ef99';
  }

  .ddmall-icon-caret-up::before {
    content: '\ef9a';
  }

  .ddmall-icon-question::before {
    content: '\e60c';
  }

  .ddmall-icon-remove::before {
    content: '\ef93';
  }

  .ddmall-icon-close-circle::before {
    content: '\e619';
  }

  .ddmall-icon-filter::before {
    content: '\ef92';
  }

  .ddmall-icon-search::before {
    content: '\ef91';
  }

  .ddmall-icon-arrow::before {
    content: '\ef94';
  }

  .ddmall-icon-back::before {
    content: '\ef90';
  }
</style>
